var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-md-12" },
      [
        _c(
          "v-toolbar",
          {
            staticClass: "pl-5 elevation-0",
            attrs: { color: "#5C8A9E", dark: "", dense: "" },
          },
          [
            !_vm.usesBottomNav
              ? _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "", "open-delay": 1000 },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-app-bar-nav-icon",
                                _vm._g(
                                  _vm._b(
                                    { on: { click: _vm.handleSidebar } },
                                    "v-app-bar-nav-icon",
                                    attrs,
                                    false
                                  ),
                                  on
                                )
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2335458644
                    ),
                  },
                  [_c("span", [_vm._v("Menú principal")])]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "position-absolute d-flex align-items-center",
                staticStyle: { right: "5px" },
              },
              [_c("NotificationBell")],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }